import styled from "styled-components";
import { Grid, Typography } from "@material-ui/core";

export const STModalWrapper = styled(Grid)`
  && {
    width: 350px;
    display: flex;
    justify-content: center;
  }
`;

export const STTypography = styled(Typography)`
  && {
    margin-top: 24px;
    margin-bottom: 24px;
  }
`;
